
export const funcValidateEmail = (email: string) => email.length >= 10 && /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(email);

export const funcValidateMessage = (message: string) => /^[\s\S]{0,255}$/.test(message);

export const funcValidateSubject = (subject: string) => /^[\s\S]{0,100}$/.test(subject);
